import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Banner from '../../DirectoryPage/BOTLocation/components/Banner'
import Location from './components/Location'
import Button from 'components/common/Button/Button'
import { Description, Wrapper } from '../../Shared.styles'

const BOTCityDetails = ({
  title,
  secondTitle,
  image,
  description,
  stores = [],
  hasStores,
  onClick = () => {}
}) =>
  <Wrapper>
    <Banner title={ title } image={ image } />
    <Description>{ description }</Description>
    <CustomButton narrow onClick={ onClick }>Book Appointment</CustomButton>
    <Container>
      <Title>{ secondTitle }</Title>
      { !hasStores && <Placeholder>Sorry, there are no stores in this location yet.</Placeholder> }
      { hasStores &&
      <Locations>
        { stores.map(store =>
          <Location { ...store } />
        )}
      </Locations>
      }
    </Container>
  </Wrapper>

BOTCityDetails.propTypes = {
  description: PropTypes.string,
  hasStores: PropTypes.bool,
  image: PropTypes.string,
  onClick: PropTypes.func,
  secondTitle: PropTypes.string,
  stores: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default BOTCityDetails

const Container = styled.div`
  padding: 30px 20px 60px;
  background-color: #ececec;
`

const Title = styled.h3`
  margin: 0 0 30px 0;
  ${Mixin.font.GothamBold(18, 600, 22)};
  text-align: center;
  text-transform: uppercase;
  transform: scale(1, 1.3);
`

const Locations = styled.div`
  display: grid;
  grid-template-columns: repeat(5, auto);
  column-gap: 20px;
  row-gap: 20px;
  ${Media.tablet`
    grid-template-columns: repeat(3, auto);
  `}

  ${Media.mobile`
    grid-template-columns: repeat(3, auto);
  `}

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, auto);
    column-gap: 10px;
    row-gap: 10px;
  }
`

const CustomButton = styled(Button)`
  margin: 0 0 60px 0;
  cursor: pointer;
`

const Placeholder = styled.p`
  text-align: center;
  margin: 0;
`
